import React from "react";
import { Container } from "react-bootstrap";

const First = () => {
  return (
    <>
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <h1>Industrial Automation</h1>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
